// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type ClSpatialrepresentationtypeKey,
  ClSpatialrepresentationtypeKeyFromJSON,
  ClSpatialrepresentationtypeKeyToJSON,
} from "../models/ClSpatialrepresentationtypeKey";
import { type ClTopicKey, ClTopicKeyFromJSON, ClTopicKeyToJSON } from "../models/ClTopicKey";
import { type Dataset, DatasetFromJSON, DatasetToJSON } from "../models/Dataset";
import {
  type DatasetFromLizardRaster,
  DatasetFromLizardRasterFromJSON,
  DatasetFromLizardRasterToJSON,
} from "../models/DatasetFromLizardRaster";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type FacetPageDataset,
  FacetPageDatasetFromJSON,
  FacetPageDatasetToJSON,
} from "../models/FacetPageDataset";
import {
  type ISO19115Dataset,
  ISO19115DatasetFromJSON,
  ISO19115DatasetToJSON,
} from "../models/ISO19115Dataset";
import {
  type ISO19115DatasetUpdate,
  ISO19115DatasetUpdateFromJSON,
  ISO19115DatasetUpdateToJSON,
} from "../models/ISO19115DatasetUpdate";
import {
  type OGCWebServiceRead,
  OGCWebServiceReadFromJSON,
  OGCWebServiceReadToJSON,
} from "../models/OGCWebServiceRead";
import {
  type ResourceidentifierCode,
  ResourceidentifierCodeFromJSON,
  ResourceidentifierCodeToJSON,
} from "../models/ResourceidentifierCode";
import {
  type ResourceidentifierLink,
  ResourceidentifierLinkFromJSON,
  ResourceidentifierLinkToJSON,
} from "../models/ResourceidentifierLink";
import {
  type ResponseDatasetDataLinksInner,
  ResponseDatasetDataLinksInnerFromJSON,
  ResponseDatasetDataLinksInnerToJSON,
} from "../models/ResponseDatasetDataLinksInner";
import { type StatusCode, StatusCodeFromJSON, StatusCodeToJSON } from "../models/StatusCode";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface DatasetAddFileLakeRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
}

export interface DatasetCreateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  iSO19115Dataset: ISO19115Dataset;
}

export interface DatasetDataLinksRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
}

export interface DatasetDeleteRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
}

export interface DatasetGetDocumentRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
}

export interface DatasetImportFromLizardRasterRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetFromLizardRaster: DatasetFromLizardRaster;
}

export interface DatasetRetrieveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
}

export interface DatasetSearchRequest {
  /**
   *
   */
  tenantId: string;
  /**
   * Page size limit
   */
  limit?: number;
  /**
   * Page offset
   */
  offset?: number;
  /**
   * Field to order by
   */
  orderBy?: DatasetSearchOrderByEnum;
  /**
   * Whether ordering is case-sensitive
   */
  orderByCaseSensitive?: boolean;
  /**
   *
   */
  search?: string | null;
  /**
   *
   */
  category?: string | null;
  /**
   *
   */
  resourceType?: DatasetSearchResourceTypeEnum;
  /**
   *
   */
  resourceIdentifierCode?: ResourceidentifierCode | null;
  /**
   *
   */
  resourceIdentifierLink?: ResourceidentifierLink | null;
  /**
   *
   */
  clSpatialRepresentationTypeKey?: ClSpatialrepresentationtypeKey | null;
  /**
   *
   */
  clTopicKey?: ClTopicKey | null;
  /**
   *
   */
  facetFields?: Array<any>;
  /**
   *
   */
  facetSize?: number;
  /**
   * Status of the dataset
   */
  status?: Array<StatusCode> | null;
}

export interface DatasetThumbnailRetrieveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
}

export interface DatasetThumbnailUploadRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
  /**
   *
   */
  imageUpload: Blob;
}

export interface DatasetUpdateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
  /**
   *
   */
  iSO19115DatasetUpdate: ISO19115DatasetUpdate;
}

export interface DatasetWmsLinksRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
}

export interface JobDatasetDataLinksRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  jobId: string;
  /**
   *
   */
  datasetId: string;
  /**
   *
   */
  xJobSecret: string;
}

export interface JobDatasetRetrieveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  jobId: string;
  /**
   *
   */
  datasetId: string;
  /**
   *
   */
  xJobSecret: string;
}

export interface UserThumbnailRemoveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  datasetId: string;
}

/**
 *
 */
export class DatasetsApi extends runtime.BaseAPI {
  /**
   * Creates request options for datasetAddFileLake without sending the request
   */
  async datasetAddFileLakeRequestOpts(
    requestParameters: DatasetAddFileLakeRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetAddFileLake().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetAddFileLake().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/files`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Add a file lake to the dataset.
   * add file lake to dataset
   */
  async datasetAddFileLakeRaw(
    requestParameters: DatasetAddFileLakeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Dataset>> {
    const requestOptions = await this.datasetAddFileLakeRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DatasetFromJSON(jsonValue));
  }

  /**
   * Add a file lake to the dataset.
   * add file lake to dataset
   */
  async datasetAddFileLake(
    requestParameters: DatasetAddFileLakeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Dataset> {
    const response = await this.datasetAddFileLakeRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for datasetCreate without sending the request
   */
  async datasetCreateRequestOpts(
    requestParameters: DatasetCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetCreate().'
      );
    }

    if (requestParameters["iSO19115Dataset"] == null) {
      throw new runtime.RequiredError(
        "iSO19115Dataset",
        'Required parameter "iSO19115Dataset" was null or undefined when calling datasetCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ISO19115DatasetToJSON(requestParameters["iSO19115Dataset"]),
    };
  }

  /**
   * Create a new dataset.
   * create dataset
   */
  async datasetCreateRaw(
    requestParameters: DatasetCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Dataset>> {
    const requestOptions = await this.datasetCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DatasetFromJSON(jsonValue));
  }

  /**
   * Create a new dataset.
   * create dataset
   */
  async datasetCreate(
    requestParameters: DatasetCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Dataset> {
    const response = await this.datasetCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for datasetDataLinks without sending the request
   */
  async datasetDataLinksRequestOpts(
    requestParameters: DatasetDataLinksRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetDataLinks().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetDataLinks().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/data-links`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Inspect data links and shows additional metadata such as OGC layer names and Atom service files.
   * retrieve data links
   */
  async datasetDataLinksRaw(
    requestParameters: DatasetDataLinksRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<ResponseDatasetDataLinksInner>>> {
    const requestOptions = await this.datasetDataLinksRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ResponseDatasetDataLinksInnerFromJSON)
    );
  }

  /**
   * Inspect data links and shows additional metadata such as OGC layer names and Atom service files.
   * retrieve data links
   */
  async datasetDataLinks(
    requestParameters: DatasetDataLinksRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<ResponseDatasetDataLinksInner>> {
    const response = await this.datasetDataLinksRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for datasetDelete without sending the request
   */
  async datasetDeleteRequestOpts(
    requestParameters: DatasetDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetDelete().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Remove a specific dataset.
   * delete dataset
   */
  async datasetDeleteRaw(
    requestParameters: DatasetDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.datasetDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Remove a specific dataset.
   * delete dataset
   */
  async datasetDelete(
    requestParameters: DatasetDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.datasetDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for datasetGetDocument without sending the request
   */
  async datasetGetDocumentRequestOpts(
    requestParameters: DatasetGetDocumentRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetGetDocument().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetGetDocument().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/document`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Fetch the dataset metadata document.
   * get dataset metadata document
   */
  async datasetGetDocumentRaw(
    requestParameters: DatasetGetDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ISO19115Dataset>> {
    const requestOptions = await this.datasetGetDocumentRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ISO19115DatasetFromJSON(jsonValue));
  }

  /**
   * Fetch the dataset metadata document.
   * get dataset metadata document
   */
  async datasetGetDocument(
    requestParameters: DatasetGetDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ISO19115Dataset> {
    const response = await this.datasetGetDocumentRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for datasetImportFromLizardRaster without sending the request
   */
  async datasetImportFromLizardRasterRequestOpts(
    requestParameters: DatasetImportFromLizardRasterRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetImportFromLizardRaster().'
      );
    }

    if (requestParameters["datasetFromLizardRaster"] == null) {
      throw new runtime.RequiredError(
        "datasetFromLizardRaster",
        'Required parameter "datasetFromLizardRaster" was null or undefined when calling datasetImportFromLizardRaster().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/from-lizard-raster`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: DatasetFromLizardRasterToJSON(requestParameters["datasetFromLizardRaster"]),
    };
  }

  /**
   * Create a new dataset from a Lizard raster
   * create a dataset from a Lizard raster
   */
  async datasetImportFromLizardRasterRaw(
    requestParameters: DatasetImportFromLizardRasterRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Dataset>> {
    const requestOptions = await this.datasetImportFromLizardRasterRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DatasetFromJSON(jsonValue));
  }

  /**
   * Create a new dataset from a Lizard raster
   * create a dataset from a Lizard raster
   */
  async datasetImportFromLizardRaster(
    requestParameters: DatasetImportFromLizardRasterRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Dataset> {
    const response = await this.datasetImportFromLizardRasterRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for datasetRetrieve without sending the request
   */
  async datasetRetrieveRequestOpts(
    requestParameters: DatasetRetrieveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetRetrieve().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetRetrieve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return detailed information of an individual dataset.
   * show dataset details
   */
  async datasetRetrieveRaw(
    requestParameters: DatasetRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Dataset>> {
    const requestOptions = await this.datasetRetrieveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DatasetFromJSON(jsonValue));
  }

  /**
   * Return detailed information of an individual dataset.
   * show dataset details
   */
  async datasetRetrieve(
    requestParameters: DatasetRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Dataset> {
    const response = await this.datasetRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for datasetSearch without sending the request
   */
  async datasetSearchRequestOpts(
    requestParameters: DatasetSearchRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetSearch().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["orderBy"] != null) {
      queryParameters["order_by"] = requestParameters["orderBy"];
    }

    if (requestParameters["orderByCaseSensitive"] != null) {
      queryParameters["order_by_case_sensitive"] = requestParameters["orderByCaseSensitive"];
    }

    if (requestParameters["search"] != null) {
      queryParameters["search"] = requestParameters["search"];
    }

    if (requestParameters["category"] != null) {
      queryParameters["category"] = requestParameters["category"];
    }

    if (requestParameters["resourceType"] != null) {
      queryParameters["resourceType"] = requestParameters["resourceType"];
    }

    if (requestParameters["resourceIdentifierCode"] != null) {
      queryParameters["resourceIdentifier.code"] = requestParameters["resourceIdentifierCode"];
    }

    if (requestParameters["resourceIdentifierLink"] != null) {
      queryParameters["resourceIdentifier.link"] = requestParameters["resourceIdentifierLink"];
    }

    if (requestParameters["clSpatialRepresentationTypeKey"] != null) {
      queryParameters["cl_spatialRepresentationType.key"] =
        requestParameters["clSpatialRepresentationTypeKey"];
    }

    if (requestParameters["clTopicKey"] != null) {
      queryParameters["cl_topic.key"] = requestParameters["clTopicKey"];
    }

    if (requestParameters["facetFields"] != null) {
      queryParameters["facet_fields"] = requestParameters["facetFields"];
    }

    if (requestParameters["facetSize"] != null) {
      queryParameters["facet_size"] = requestParameters["facetSize"];
    }

    if (requestParameters["status"] != null) {
      queryParameters["status"] = requestParameters["status"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Perform a search on datasets. Supports full-text, filtering, and aggregation for faceted search.
   * search datasets
   */
  async datasetSearchRaw(
    requestParameters: DatasetSearchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FacetPageDataset>> {
    const requestOptions = await this.datasetSearchRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FacetPageDatasetFromJSON(jsonValue)
    );
  }

  /**
   * Perform a search on datasets. Supports full-text, filtering, and aggregation for faceted search.
   * search datasets
   */
  async datasetSearch(
    requestParameters: DatasetSearchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FacetPageDataset> {
    const response = await this.datasetSearchRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for datasetThumbnailRetrieve without sending the request
   */
  async datasetThumbnailRetrieveRequestOpts(
    requestParameters: DatasetThumbnailRetrieveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetThumbnailRetrieve().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetThumbnailRetrieve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/thumbnail`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Retrieve the thumbnail image of a dataset.
   * get dataset thumbnail
   */
  async datasetThumbnailRetrieveRaw(
    requestParameters: DatasetThumbnailRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>> {
    const requestOptions = await this.datasetThumbnailRetrieveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.BlobApiResponse(response);
  }

  /**
   * Retrieve the thumbnail image of a dataset.
   * get dataset thumbnail
   */
  async datasetThumbnailRetrieve(
    requestParameters: DatasetThumbnailRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob | null | undefined> {
    const response = await this.datasetThumbnailRetrieveRaw(requestParameters, initOverrides);
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }

  /**
   * Creates request options for datasetThumbnailUpload without sending the request
   */
  async datasetThumbnailUploadRequestOpts(
    requestParameters: DatasetThumbnailUploadRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetThumbnailUpload().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetThumbnailUpload().'
      );
    }

    if (requestParameters["imageUpload"] == null) {
      throw new runtime.RequiredError(
        "imageUpload",
        'Required parameter "imageUpload" was null or undefined when calling datasetThumbnailUpload().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    const consumes: runtime.Consume[] = [{ contentType: "multipart/form-data" }];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters["imageUpload"] != null) {
      formParams.append("image_upload", requestParameters["imageUpload"] as any);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/thumbnail`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: formParams,
    };
  }

  /**
   * Upload a and replace a dataset thumnail image.
   * Upload dataset thumbnail image
   */
  async datasetThumbnailUploadRaw(
    requestParameters: DatasetThumbnailUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.datasetThumbnailUploadRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Upload a and replace a dataset thumnail image.
   * Upload dataset thumbnail image
   */
  async datasetThumbnailUpload(
    requestParameters: DatasetThumbnailUploadRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any | null | undefined> {
    const response = await this.datasetThumbnailUploadRaw(requestParameters, initOverrides);
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }

  /**
   * Creates request options for datasetUpdate without sending the request
   */
  async datasetUpdateRequestOpts(
    requestParameters: DatasetUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetUpdate().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetUpdate().'
      );
    }

    if (requestParameters["iSO19115DatasetUpdate"] == null) {
      throw new runtime.RequiredError(
        "iSO19115DatasetUpdate",
        'Required parameter "iSO19115DatasetUpdate" was null or undefined when calling datasetUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/document`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: ISO19115DatasetUpdateToJSON(requestParameters["iSO19115DatasetUpdate"]),
    };
  }

  /**
   * Update existing dataset.
   * update dataset
   */
  async datasetUpdateRaw(
    requestParameters: DatasetUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Dataset>> {
    const requestOptions = await this.datasetUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DatasetFromJSON(jsonValue));
  }

  /**
   * Update existing dataset.
   * update dataset
   */
  async datasetUpdate(
    requestParameters: DatasetUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Dataset | null | undefined> {
    const response = await this.datasetUpdateRaw(requestParameters, initOverrides);
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }

  /**
   * Creates request options for datasetWmsLinks without sending the request
   */
  async datasetWmsLinksRequestOpts(
    requestParameters: DatasetWmsLinksRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling datasetWmsLinks().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling datasetWmsLinks().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/wms-links`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Inspect data links and shows the WMS ones.
   * retrieve WMS data links
   */
  async datasetWmsLinksRaw(
    requestParameters: DatasetWmsLinksRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<OGCWebServiceRead>>> {
    const requestOptions = await this.datasetWmsLinksRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(OGCWebServiceReadFromJSON)
    );
  }

  /**
   * Inspect data links and shows the WMS ones.
   * retrieve WMS data links
   */
  async datasetWmsLinks(
    requestParameters: DatasetWmsLinksRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<OGCWebServiceRead> | null | undefined> {
    const response = await this.datasetWmsLinksRaw(requestParameters, initOverrides);
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }

  /**
   * Creates request options for jobDatasetDataLinks without sending the request
   */
  async jobDatasetDataLinksRequestOpts(
    requestParameters: JobDatasetDataLinksRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling jobDatasetDataLinks().'
      );
    }

    if (requestParameters["jobId"] == null) {
      throw new runtime.RequiredError(
        "jobId",
        'Required parameter "jobId" was null or undefined when calling jobDatasetDataLinks().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling jobDatasetDataLinks().'
      );
    }

    if (requestParameters["xJobSecret"] == null) {
      throw new runtime.RequiredError(
        "xJobSecret",
        'Required parameter "xJobSecret" was null or undefined when calling jobDatasetDataLinks().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters["xJobSecret"] != null) {
      headerParameters["x-job-secret"] = String(requestParameters["xJobSecret"]);
    }

    let urlPath = `/tenants/{tenant_id}/jobs/{job_id}/datasets/{dataset_id}/data-links`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{job_id}", encodeURIComponent(String(requestParameters["jobId"])));
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Inspect data links and shows additional metadata such as OGC layer names and Atom service files.
   * retrieve data links (from a job)
   */
  async jobDatasetDataLinksRaw(
    requestParameters: JobDatasetDataLinksRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<ResponseDatasetDataLinksInner>>> {
    const requestOptions = await this.jobDatasetDataLinksRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ResponseDatasetDataLinksInnerFromJSON)
    );
  }

  /**
   * Inspect data links and shows additional metadata such as OGC layer names and Atom service files.
   * retrieve data links (from a job)
   */
  async jobDatasetDataLinks(
    requestParameters: JobDatasetDataLinksRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<ResponseDatasetDataLinksInner> | null | undefined> {
    const response = await this.jobDatasetDataLinksRaw(requestParameters, initOverrides);
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }

  /**
   * Creates request options for jobDatasetRetrieve without sending the request
   */
  async jobDatasetRetrieveRequestOpts(
    requestParameters: JobDatasetRetrieveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling jobDatasetRetrieve().'
      );
    }

    if (requestParameters["jobId"] == null) {
      throw new runtime.RequiredError(
        "jobId",
        'Required parameter "jobId" was null or undefined when calling jobDatasetRetrieve().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling jobDatasetRetrieve().'
      );
    }

    if (requestParameters["xJobSecret"] == null) {
      throw new runtime.RequiredError(
        "xJobSecret",
        'Required parameter "xJobSecret" was null or undefined when calling jobDatasetRetrieve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (requestParameters["xJobSecret"] != null) {
      headerParameters["x-job-secret"] = String(requestParameters["xJobSecret"]);
    }

    let urlPath = `/tenants/{tenant_id}/jobs/{job_id}/datasets/{dataset_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{job_id}", encodeURIComponent(String(requestParameters["jobId"])));
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return detailed information of an individual dataset.
   * show dataset details (from a job)
   */
  async jobDatasetRetrieveRaw(
    requestParameters: JobDatasetRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Dataset>> {
    const requestOptions = await this.jobDatasetRetrieveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => DatasetFromJSON(jsonValue));
  }

  /**
   * Return detailed information of an individual dataset.
   * show dataset details (from a job)
   */
  async jobDatasetRetrieve(
    requestParameters: JobDatasetRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Dataset | null | undefined> {
    const response = await this.jobDatasetRetrieveRaw(requestParameters, initOverrides);
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }

  /**
   * Creates request options for userThumbnailRemove without sending the request
   */
  async userThumbnailRemoveRequestOpts(
    requestParameters: UserThumbnailRemoveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling userThumbnailRemove().'
      );
    }

    if (requestParameters["datasetId"] == null) {
      throw new runtime.RequiredError(
        "datasetId",
        'Required parameter "datasetId" was null or undefined when calling userThumbnailRemove().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/datasets/{dataset_id}/thumbnail`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{dataset_id}",
      encodeURIComponent(String(requestParameters["datasetId"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Remove a thumbnail of a dataset.
   * Remove dataset thumbnail
   */
  async userThumbnailRemoveRaw(
    requestParameters: UserThumbnailRemoveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>> {
    const requestOptions = await this.userThumbnailRemoveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.BlobApiResponse(response);
  }

  /**
   * Remove a thumbnail of a dataset.
   * Remove dataset thumbnail
   */
  async userThumbnailRemove(
    requestParameters: UserThumbnailRemoveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob | null | undefined> {
    const response = await this.userThumbnailRemoveRaw(requestParameters, initOverrides);
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }
}

/**
 * @export
 */
export const DatasetSearchOrderByEnum = {
  Score: "score",
  Popularity: "popularity",
  Id: "id",
  Id2: "-id",
  CreatedAt: "created_at",
  CreatedAt2: "-created_at",
  UpdatedAt: "updated_at",
  UpdatedAt2: "-updated_at",
} as const;
export type DatasetSearchOrderByEnum =
  (typeof DatasetSearchOrderByEnum)[keyof typeof DatasetSearchOrderByEnum];
/**
 * @export
 */
export const DatasetSearchResourceTypeEnum = {
  Dataset: "dataset",
} as const;
export type DatasetSearchResourceTypeEnum =
  (typeof DatasetSearchResourceTypeEnum)[keyof typeof DatasetSearchResourceTypeEnum];
